import { useQuery } from '@tanstack/react-query';
import { useApi } from '@/api/ApiContext';
import type { LocaleCode } from '@/api/models';
import type { GetShiftLedgerSummaryResponse } from '@/api/handlers/resources/shifts';
import type { ApiResponse } from '@/api/handlers/responses';
import { ShiftsQueryKeys } from './shiftsQueryKeys';

const STALE_TIME_MS = 30_000;

/**
 * One shift's ledger rollup.
 *
 * No `keepPreviousData`: selecting a different shift is a different shift, and
 * showing the previous one's figures under the new one's heading for a beat is
 * the kind of wrong answer this folder exists to avoid. The panel skeletons
 * instead.
 */
export const useShiftLedgerSummaryQuery = (
    shiftId: string | null,
    locale: LocaleCode,
    enabled: boolean,
) => {
    const { apiClient } = useApi();

    return useQuery<ApiResponse<GetShiftLedgerSummaryResponse>>({
        queryKey: ShiftsQueryKeys.ledgerSummary(shiftId ?? '', locale),
        queryFn: () => apiClient.shifts.getLedgerSummary(shiftId!, locale),
        enabled: enabled && Boolean(shiftId),
        staleTime: STALE_TIME_MS,
    });
};
